import React from 'react';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import faq from './faqTexts';
import Shadow from './shadow';
import useMain from './../../hooks/useMain';

const Accordion = withStyles({
	root: {
		boxShadow: 'none',
		borderRadius: 0,
		'&:not(:last-child)': {
			borderBottom: 0,
		},
		'&:before': {
			display: 'none',
		},
		'&$expanded': {
			margin: 'auto',
		},
	},
	expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
	root: {
		marginBottom: -1,
		borderRadius: 0,
		minHeight: 56,
		'&$expanded': {
			minHeight: 56,
		},
	},
	content: {
		'&$expanded': {
			margin: '12px 0',
		},
	},
	expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiAccordionDetails);

function FAQ() {
	const { theme } = useMain();

	const getAccordionStyle = {
		border: theme === 'light' ? 'none' : '2px solid rgb(65, 65, 65)',
	};

	const getSummaryStyle = {
		backgroundColor: theme === 'light' ? '#faf6ff' : '#282828',
		color: theme === 'light' ? '#656565' : '#949494',
	};

	const getDetailsStyle = {
		backgroundColor: theme === 'light' ? '#f2ebfd' : '#000',
		color: theme === 'light' ? '#656565' : '#949494',
	};

	return (
		<div className='pt-5'>
			<div
				id='faq'
				className='container pb-5'>
				<div className='row'>
					<div className='col-12'>
						{faq.map((item, index) => (
							<Accordion
								key={index}
								style={getAccordionStyle}>
								<AccordionSummary
									expandIcon={
										<ExpandMore
											style={{
												color: theme === 'light' ? '#656565' : '#949494',
											}}
										/>
									}
									style={getSummaryStyle}>
									<div className='d-flex align-items-center'>
										<span className='ms-4 me-5 fs-2 text-set3'>
											<b>{String(index + 1).padStart(2, '0')}</b>
										</span>
										<b>{item.title}</b>
									</div>
								</AccordionSummary>
								<AccordionDetails style={getDetailsStyle}>
									<div className='ms-5'>{item.content}</div>
								</AccordionDetails>
							</Accordion>
						))}
					</div>
				</div>
			</div>
			<Shadow />
		</div>
	);
}

export default FAQ;
